export const getButtonBorderStyle = (defaultStyles) => defaultStyles.borderStyle || 'solid';
export const getButtonBorderWidth = (customStyles, defaultStyles) => customStyles?.borderWidth || defaultStyles.borderWidth || '0px';
export const getButtonBorderColor = (customStyles, defaultStyles) => customStyles?.borderColor || defaultStyles.borderColor || 'transparent';
export const getButtonBorderRadius = (customStyles, defaultStyles) => customStyles?.borderRadius || defaultStyles.borderRadius;
export const getButtonMaxWidth = (defaultStyles, fallbackValue = undefined, minValue = Infinity) => {
    const width = defaultStyles.maxWidth || fallbackValue || '300px';
    const widthPx = parseInt(width, 10);
    return Math.min(widthPx, minValue);
};
export const getButtonMinWidth = (customStyles, defaultStyles, fallbackValue = undefined, minValue = Infinity) => {
    const width = defaultStyles.minWidth || fallbackValue || '140px';
    const borderWidth = getButtonBorderWidth(customStyles, defaultStyles);
    const widthPx = parseInt(width, 10);
    const borderWidthPx = parseInt(String(borderWidth), 10);
    return Math.min(widthPx, minValue) - borderWidthPx * 2;
};
//# sourceMappingURL=button-utils.js.map